import { createTheme } from "@mui/material/styles";
export const globalTheme = createTheme({
    components: {
        MuiTypography: {
            styleOverrides: {
                h6: {
                    fontSize: "1.8rem",
                    fontFamily: "BrownStd-Bold",
                },
                subtitle2: {
                    fontSize: "1.6rem",
                    fontFamily: "BrownStd-Bold",
                },
                body1: {
                    fontSize: "1.6rem",
                    fontFamily: "'LinetoBrownProRegular', Arial, sans-serif",
                },
                body2: {
                    fontSize: "1.4rem",
                    fontFamily: "'LinetoBrownProRegular', Arial, sans-serif",
                },
            },
        },
        MuiIconButton: {
            styleOverrides: {
                root: {
                    color: "#009fe0", // due to IE11: "var(--clr-secondary)",
                    "& span": {
                        color: "inherit",
                    },
                    "&$disabled": {
                        color: "#dce0e8", // due to IE11: backgroundColor: "var(--clr-grey-light-1)",
                    },
                },
            },
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    fontSize: "1.4rem",
                    fontFamily: "BrownStd-Regular",
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                containedPrimary: {
                    color: "white",
                    fontSize: "1.4rem",
                    backgroundColor: "#009fe0",
                    "&:hover": {
                        backgroundColor: "#93d1e9",
                    },
                },
                textPrimary: {
                    backgroundColor: "#009fe0",
                    "&:hover": {
                        backgroundColor: "#93d1e9",
                    },
                },
            },
        },
        MuiSvgIcon: {
            styleOverrides: {
                root: {
                    margin: "0.1rem",
                    fontSize: "2rem",
                },
            },
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    fontFamily: "BrownStd-Regular",
                    "&:before": {
                        display: "NONE",
                    },
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    fontSize: "1.2rem",
                    fontFamily: "BrownStd-Regular",
                },
            },
        },
        MuiInputBase: {
            styleOverrides: {
                root: {
                    fontFamily: "BrownStd-Regular",
                },
            },
        },
    },
});
